export const getAttribute = '/attribute';
export const addAttribute = '/attribute/add-attribute';
export const updateAttribute = '/attribute/';
export const deleteAttribute = '/attribute/';
